<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4></h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>

  <div *ngIf="isLoading" class="small-spinner">
    <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
  </div>

  <div *ngIf="hasLoadError" class="text-danger">
    Could not load competencies. Close and try again.
  </div>

  <form *ngIf="!isLoading && !hasLoadError">
    <div class="form-group" [formGroup]="form">
      <label>Competencies</label>
      <p-multiSelect
          class="form-control"
          [options]="allCompetencies"
          defaultLabel="Select Competencies..."
          [style]="{ width: '100%' }"
          formControlName="competencies"
          >
      </p-multiSelect>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" [disabled]="isLoading || hasLoadError || isSubmitting || !form || !form.valid || !form.dirty" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
